import { ApiService, ApiServiceGetResponse } from "@services"
import { MainInventoryBackendCard } from "@store"

export type DailyLimit = {
  limit: number,
  used: number
}

export type AdIntentType = 'unlock_quest' | 'hint' | 'tap' | 'skip_stars'

export type AdIntent = {
  id: string
  type: AdIntentType
  is_resolved: boolean
  payload: string
  user_id: number
}

export type AdIntentResult = {
  intent_id: string
  result: unknown
  status: string
}

export const createAdIntent = async (
  type: AdIntentType,
  payload?: string,
): Promise<ApiServiceGetResponse<AdIntentResult>> => {
  const { ok, data } = await ApiService.post({
    endpoint: `/api/v1/user/ads/intent`,
    data: { type, ...(payload ? { payload } : {}) },
  })

  return { ok, data: data || null }
}

export const getAdIntent = async (): Promise<ApiServiceGetResponse<AdIntent>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/user/ads/intent`,
  })

  return { ok, data: data || null }
}

export const getReward = async (
  ): Promise<ApiServiceGetResponse<MainInventoryBackendCard>> => {
    const { ok, data } = await ApiService.get({
      endpoint: `/api/v1/user/ads/reward`,
    })

    return { ok, data: data || null }
}

export const getDailyLimit = async (): Promise<ApiServiceGetResponse<Record<AdIntentType, DailyLimit>>> => {
  const { ok, data } = await ApiService.get({
    endpoint: `/api/v1/user/ads/daily-limit`,
  })

  return { ok, data: data || null }
}